/* ==========================================================================
   PRICE ON REQUEST — modal behaviour, v123

   One modal serves every "Ask for price" button on the page. The button
   carries the piece:

       data-poa-open
       data-poa-title  "Pichwai Shrinathji, 24x36"
       data-poa-url    "/products/pichwai-shrinathji"
       data-poa-sku    optional
       data-poa-mode   optional, "soldout" (v148)

   On click those are copied into the modal's hidden inputs, so the email
   that arrives in the store inbox names the exact piece and links to it.

   v148: the same modal serves "Enquire now" on sold-out pieces. A button
   with data-poa-mode="soldout" swaps the heading, intro, WhatsApp message
   and the hidden "Enquiry type" field, so the inbox can tell a sold-out
   enquiry from a price request. Every other button puts the defaults back.

   Delegated from document, so buttons that arrive later — the collection
   "Load more" appends cards through polish.js — work without rebinding.

   Remove this file, assets/enquiry.css and snippets/price-enquiry-modal.liquid
   to revert.
   ========================================================================== */
(function () {
  'use strict';

  var modal = document.querySelector('[data-peq-modal]');
  if (!modal) return;

  var panel     = modal.querySelector('.peq__panel');
  var fTitle    = modal.querySelector('[data-peq-field-title]');
  var fUrl      = modal.querySelector('[data-peq-field-url]');
  var fSku      = modal.querySelector('[data-peq-field-sku]');
  var piece     = modal.querySelector('[data-peq-piece]');
  var pieceName = modal.querySelector('[data-peq-piece-name]');
  var pieceLink = modal.querySelector('[data-peq-piece-link]');
  var waLink    = modal.querySelector('[data-peq-wa]');
  var lastFocus = null;

  /* v148: copy that changes with the button's mode. Defaults are read from
     the rendered modal, so the theme settings still own the price wording. */
  var fType   = modal.querySelector('input[name="contact[Enquiry type]"]');
  var heading = modal.querySelector('.peq__head h2');
  var intro   = modal.querySelector('.peq__intro');
  var DEFAULT_COPY = {
    type:    fType ? fType.value : '',
    heading: heading ? heading.textContent : '',
    intro:   intro ? intro.textContent : ''
  };
  var SOLDOUT_COPY = {
    type:    'Sold out enquiry',
    heading: 'Enquire about this piece',
    intro:   'This piece has been sold. Share your details and our curator will suggest similar pieces or a commission from the same artisan.'
  };

  /* Relative product paths become absolute so the email is one click away. */
  function absolute(url) {
    if (!url) return window.location.href;
    if (/^https?:\/\//i.test(url)) return url;
    return window.location.origin + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function open(data) {
    data = data || {};
    var title   = data.title || '';
    var url     = absolute(data.url);
    var soldout = data.mode === 'soldout';
    var copy    = soldout ? SOLDOUT_COPY : DEFAULT_COPY;

    if (fTitle) fTitle.value = title;
    if (fUrl)   fUrl.value   = url;
    if (fSku)   fSku.value   = data.sku || '';
    if (fType)   fType.value = copy.type;
    if (heading) heading.textContent = copy.heading;
    if (intro)   intro.textContent = copy.intro;

    /* Show the piece back to the visitor so a mis-click is obvious. */
    if (piece) {
      if (title) {
        if (pieceName) pieceName.textContent = title;
        if (pieceLink) pieceLink.href = url;
        piece.hidden = false;
      } else {
        piece.hidden = true;
      }
    }

    /* The WhatsApp fallback inside the modal carries the same piece. */
    if (waLink) {
      var base = waLink.href.split('?')[0];
      var msg;
      if (!title) {
        msg = 'Hi, I would like to enquire about a piece.';
      } else if (soldout) {
        msg = 'Hi, I am interested in this sold-out piece: ' + title + ' - ' + url + ' Do you have something similar?';
      } else {
        msg = 'Hi, I would like to know the price of this piece: ' + title + ' — ' + url;
      }
      waLink.href = base + '?text=' + encodeURIComponent(msg);
    }

    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('peq-open');
    /* Next frame, so the opening transition actually runs. */
    requestAnimationFrame(function () { modal.classList.add('is-open'); });

    var first = modal.querySelector('input:not([type=hidden]), textarea, button');
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('peq-open');
    window.setTimeout(function () { modal.hidden = true; }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  /* Open — delegated, so dynamically loaded cards are covered. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-poa-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open({
      title: btn.getAttribute('data-poa-title'),
      url:   btn.getAttribute('data-poa-url'),
      sku:   btn.getAttribute('data-poa-sku'),
      mode:  btn.getAttribute('data-poa-mode')
    });
  });

  /* Close — X, veil, and the success panel's button all carry data-peq-close. */
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-peq-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  /* Keep tabbing inside the dialog while it is open. */
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !panel) return;
    var items = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type=hidden]), textarea, select'
    );
    if (!items.length) return;
    var first = items[0];
    var last  = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* Never post an empty product URL — fall back to the page being viewed. */
  var form = modal.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      if (fUrl && !fUrl.value) fUrl.value = window.location.href;
    });
  }

  /* A native contact form reloads the page on submit. Shopify appends
     ?contact_posted=true, and Liquid has already swapped the form for the
     thank-you panel — so re-open the modal on that reload rather than
     dropping the visitor back on the grid with no confirmation. */
  if (modal.querySelector('[data-peq-success]')) {
    open({});
  }
})();